module.exports = __webpack_public_path__ + "img/partner-tourismus-montafon_rot.a7bce6c3.svg";